import { render, staticRenderFns } from "./SjdTable.vue?vue&type=template&id=0efaafea&scoped=true&"
import script from "./SjdTable.vue?vue&type=script&lang=js&"
export * from "./SjdTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efaafea",
  null
  
)

export default component.exports